module.exports = __webpack_public_path__ + "static/media/image-broken.5222b45d.svg";